import axios from 'axios';

export function sidebarActions(data, parent, types) {
  return (dispatch) => {
    dispatch({type: types, data})
  };
}

export function counterAction(url, types) {
  return (dispatch) => {
    axios.get(url)
      .then((response) => {
        return response.data;
      })
      .then((items) => {
        dispatch({type: types, items})
      })
      .catch(error => {
        console.log(error)
      })
  };
}